import { useState } from "react";

import { cn } from "@/libs/utils";

import { ValueType } from "@/types/bid";

type Props = {
  label: string;
  value: string;
  toggleValue: boolean;
  onClick: ({}: ValueType) => void;
};
export default function CommonButtonToggle({
  label,
  value,
  toggleValue,
  onClick,
}: Props) {
  return (
    <div
      className={cn(
        "flex justify-center items-center text-[10px] font-semibold text-gray-A rounded-[4px] cursor-pointer",
        {
          "bg-dark-red text-white": toggleValue,
          "bg-gray-E": !toggleValue,
        }
      )}
      onClick={() => {
        onClick({ label, value });
      }}
    >
      {label}
    </div>
  );
}
